import { skipToken } from "@reduxjs/toolkit/query";
import { useParams } from "react-router-dom";
import { useGetMedicationsPerProductQuery } from "src/api/services/medicationsApi";
import { MatchParam } from "src/constants/matches";
import { useColumns } from "./useColumns";
import { useMemo } from "react";
import { Box, Button, LinearProgress, Stack } from "@mui/material";
import DataTable from "src/components/DataTable";
import { useManageModal } from "src/hooks/useManageModal";
import AddProductMedicationModal from "./components/AddProductMedicationModal";

const ProductMedications = () => {
  const { productId } = useParams<MatchParam<"PRODUCT_ID">>();
  const { data = [], isFetching } = useGetMedicationsPerProductQuery(
    productId ? { product_id: productId } : skipToken,
  );
  const columns = useColumns();
  const height = useMemo(() => window.innerHeight - 104 - 64 - 34, []);
  const [open, { handleClose, handleOpen }] = useManageModal();

  return (
    <Stack gap={2} sx={{ width: "100%", alignSelf: "end" }}>
      <Button
        sx={{ width: "fit-content", alignSelf: "end" }}
        onClick={handleOpen}
      >
        + Add Medication
      </Button>
      <Stack gap={0} sx={{ width: "100%", minWidth: 0 }}>
        <Box height={4}>
          {isFetching ? (
            <LinearProgress sx={{ backgroundColor: "red" }} />
          ) : null}
        </Box>
        <DataTable
          data={data}
          columns={columns}
          height={height}
          primaryKey="id"
        />
      </Stack>
      <AddProductMedicationModal open={open} onClose={handleClose} />
    </Stack>
  );
};

export default ProductMedications;
